module.exports = __webpack_public_path__ + "img/support_e9.9053bc82.png";